//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Swiper, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Autoplay])
export default {
  name: 'HomeStreamAdComp',
  props: {
    list: { // 数据列表
      type: Array, default: () => []
    }
  },
  data () {
    return {
      adSwipe: null,
      defaultPic: 'https://resources.interface003.com/web20/img/default/dealer-default.png' // 默认图片
    }
  },
  computed: {
    ...mapState(['screenWidth', 'locale', 'suffix'])
  },
  methods: {
    getUrl (item) {
      let url = ''
      if (item.jump == 1) url = `https://www.wikifx.${this.suffix}/${this.locale}/dealer/${item.code}.html`
      else if (item.jump == 2) url = item.url
      else if (item.jump == 3) url = `https://www.wikifx.${this.suffix}/${this.locale}/newsdetail/${item.code}.html`
      else if (item.jump == 4) url = 'javascript:void(0);'
      else if (item.jump == 5) url = 'javascript:void(0);'
      else if (item.jump == 6) url = 'javascript:void(0);'
      return url
    }
  }
}
